// TODO move to job dispatcher folder

export enum EventStatus {
  Unknown = 0,
  Complete = 1,
  InProgress = 2,
  Waiting = 3,
  Failed = 4
}

export const EventStatusMapping: Record<EventStatus, string> = {
  [EventStatus.Unknown]: '-- Select Type --',
  [EventStatus.Complete]: 'Complete',
  [EventStatus.InProgress]: 'In Progress',
  [EventStatus.Waiting]: 'Waiting',
  [EventStatus.Failed]: 'Failed'
};
